/** @returns Debounced function that runs only after waitTime(ms) has elapsed since the last time it was last invoked. */
const debounce = <F extends (...args: any[]) => any>(
  fn: F,
  waitTime: number
): ((...args: Parameters<F>) => void) & {
  cancel: () => void;
  flush: () => void;
} => {
  let timeout: number | undefined;
  let lastArgs: Parameters<F> | undefined;
  let lastThis: ThisParameterType<F>;

  function debounced(this: ThisParameterType<F>, ...args: Parameters<F>) {
    lastArgs = args;
    lastThis = this;
    window.clearTimeout(timeout);

    timeout = window.setTimeout(() => {
      timeout = undefined;
      fn.apply(lastThis, lastArgs as Parameters<F>);
    }, waitTime);
  }
  debounced.cancel = () => {
    window.clearTimeout(timeout);
    timeout = undefined;
  };

  debounced.flush = () => {
    if (timeout !== undefined) {
      window.clearTimeout(timeout);
      timeout = undefined;
      fn.apply(lastThis, lastArgs as Parameters<F>);
    }
  };
  return debounced as ((...args: Parameters<F>) => void) & {
    cancel: () => void;
    flush: () => void;
  };
};

export default debounce;
